<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Edit User Staff</h5>
            </template>
            <b-form @submit.prevent="openModalConfirm">
                <div class="form-content-wrapper mb-3">
                    <b-row>
                        <b-col md="4">
                            <b-form-group label="Full Name">
                                <b-form-input v-model="input.fullname" name="fullName" required></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group label="User Name">
                                <b-form-input v-model="input.username" name="userName" required></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group label="Level - Role">
                                <multiselect name="levelRole"
                                    :value="optionRole.find(item => item.id == input.role) || null"
                                    :options="optionRole" :internal-search="true" :allow-empty="false"
                                    deselect-label="" select-label="" label="name" track-by="id"
                                    placeholder="Pilih Level - Role"
                                    @input="input.role = $event ? $event.id : null" />
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group label="Cabang">
                        <div class="d-flex">
                            <multiselect
                                name="cabang"
                                v-model="input.cabang" 
                                :options="optionCabang" 
                                :internal-search="true"
                                :allow-empty="true"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="name"
                                placeholder="-- Pilih Cabang --"
                            />
                        </div>
                    </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group label="Email">
                                <b-form-input v-model="input.email" name="email" type="email"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group label="No. Hp">
                                <b-form-input v-model="input.noHp" name="noHp"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group label="Status">
                                <b-form-select v-model="input.isActive" name="status" :options="optionStatus">
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="userStaffUpdateBtn" variant="pgiBtn">Update</b-button>
                </div>
            </b-form>
        </b-card>
        <ModalConfirm id="modal-confirm-edit" title="Confirm Edit User Staff" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah user staff ini?" @submit="onSubmit" />
    </div>
</template>

<script>
import { setTimeout } from 'timers';
export default {
    name: 'edit-user-staff',
    data(){
        return{
            id: null,
            initStatus: 0,
            isSubmitting: false,
            input: {
                fullname: "",
                username: "",
                role: {},
                cabang: {},
                email: "",
                noHp: "",
                isActive: null
            },
            optionRole: [],
            optionCabang: [],
            optionStatus: [
                { value: true, text: 'Aktif'},
                { value: false, text: 'Tidak Aktif'},
            ],
            isLoading: false
        }
    },
    methods: {
        init(){
            this.initStatus = 0
            this.id = this.$route.params.id

            let getRole = this.$axios.get("role/").then(response => {
                this.optionRole = response.data

                for (var x of this.optionRole) {
                    x.name = "Level "+x.level+" - "+x.name
                }
            })
            
            let getCabang = this.$axios.get("cabang/all-selection").then(response => {
                response.data.forEach((element) => {
                    if(element.id != this.srcCabangId)
                        this.optionCabang.push(element)
                })
            })

            let getSingleUserStaff = this.$axios.get(`user/${this.id}`).then(response => {
                this.userStaff = response.data

                //----------------- Inisialisasi Data User Staff -----------------

                this.input.fullname = this.userStaff.fullname
                this.input.username = this.userStaff.username
                this.input.role = this.userStaff.role.id
                this.input.cabang = this.userStaff.cabang
                this.input.email = this.userStaff.email
                this.input.noHp = this.userStaff.noHp
                this.input.isActive = this.userStaff.isActive
            })

            Promise.all([getRole, getCabang, getSingleUserStaff]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },


        //----------------- Fungsi Submit Data -----------------

        onSubmit() {
            let payload = new FormData()

            //----------------- Append Data User Staff -----------------

            payload.append('id', this.id)
            payload.append('username', this.input.username)
            payload.append('fullname', this.input.fullname)

            if (this.$helper.isNotNullAndNotEmpty(this.input.email)) payload.append('email', this.input.email)
            if (this.$helper.isNotNullAndNotEmpty(this.input.noHp))  payload.append('noHp', this.input.noHp)
            
            payload.append('roleId', this.input.role)
            payload.append('cabangId', this.input.cabang.id)
            payload.append('isActive', this.input.isActive)


            //----------------- Submit Semua Data -----------------
    
            this.isSubmitting = true

            this.$axios.post('user/', payload).then(response => {
                this.$helper.setFlash(`User Staff baru telah berhasil diubah!`)
                let path = this.$route.path.split('/')
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },


        //----------------- Fungsi Lain -----------------

        openModalConfirm(){
            this.$bvModal.show("modal-confirm-edit")
        }

    },

    created(){
        this.init()
    }
}
</script>
